var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopiaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 43,
    viewBox: "0 0 83 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0889 0C18.3692 0 0 19.2236 0 43H82.1778C82.1778 19.2236 63.6878 0 41.0889 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3203 23.2247V20.0631H15.4955V17.0277L18.8793 15.0042V20.0631H21.1754V23.2247H18.8793V27.3983C18.8793 28.4101 19.0002 29.0424 19.2419 29.2954C19.4836 29.5483 20.2088 29.6747 21.1754 29.6747V33.0895H20.692C18.7585 33.0895 17.3083 32.7101 16.5831 31.8247C15.8582 30.9395 15.3748 29.5483 15.3748 27.3983V23.2247H13.3203Z",
    fill: "#1264E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0205 31.3185C31.8121 32.5833 30.2409 33.3421 28.4282 33.3421C26.6154 33.3421 25.0444 32.7096 23.836 31.3185C22.6275 30.0537 21.9023 28.4097 21.9023 26.5126C21.9023 24.6156 22.5065 22.9715 23.836 21.7067C25.0444 20.4421 26.6154 19.6833 28.4282 19.6833C30.2409 19.6833 31.8121 20.3156 33.0205 21.7067C34.229 22.9715 34.9541 24.6156 34.9541 26.5126C34.9541 28.4097 34.3498 30.0537 33.0205 31.3185ZM28.4276 29.9274C29.2736 29.9274 29.9988 29.5479 30.6029 28.9156C31.2071 28.2833 31.5698 27.3979 31.5698 26.5126C31.5698 25.6274 31.2071 24.7421 30.6029 24.1097C29.9988 23.4774 29.2736 23.0979 28.4276 23.0979C27.5817 23.0979 26.8565 23.4774 26.2523 24.1097C25.6482 24.7421 25.4064 25.6274 25.4064 26.5126C25.4064 27.3979 25.6482 28.2833 26.2523 28.9156C26.8565 29.5479 27.5817 29.9274 28.4276 29.9274Z",
    fill: "#1264E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5332 33.3421C41.8414 33.3421 40.6328 32.8362 39.7869 31.8244V39.1597H36.2822V19.9362H39.666V21.4538C40.6328 20.3156 41.8414 19.6833 43.4124 19.6833C44.1375 19.6833 44.8626 19.8097 45.5876 20.0626C46.3127 20.3156 46.9171 20.6949 47.5213 21.3274C48.1255 21.8333 48.6089 22.5921 48.9715 23.4774C49.334 24.3626 49.4548 25.3744 49.4548 26.5126C49.4548 28.6626 48.8506 30.3067 47.5213 31.5715C46.4337 32.7097 45.1042 33.3421 43.5332 33.3421ZM42.8086 30.0538C43.7753 30.0538 44.5004 29.6744 45.2255 29.0421C45.8297 28.4097 46.1924 27.5244 46.1924 26.5126C46.1924 25.5008 45.8297 24.6156 45.2255 23.9833C44.6213 23.3508 43.7753 22.9715 42.8086 22.9715C41.8418 22.9715 41.1166 23.3508 40.5125 23.9833C39.9081 24.6156 39.5456 25.5008 39.5456 26.5126C39.5456 27.5244 39.9081 28.2833 40.5125 29.0421C41.1166 29.6744 41.9625 30.0538 42.8086 30.0538Z",
    fill: "#1264E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7852 33.0889V19.9359H54.1689V33.0889H50.7852Z",
    fill: "#1264E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6607 33.3421C60.2105 33.3421 58.7604 32.7096 57.5518 31.5715C56.3433 30.3067 55.6182 28.6626 55.6182 26.5126C55.6182 24.9949 55.9808 23.7303 56.585 22.7185C57.1893 21.7067 58.0352 20.9478 58.8812 20.4421C59.7271 19.9362 60.6939 19.6833 61.6607 19.6833C63.2318 19.6833 64.4403 20.1892 65.4071 21.2008V19.9362H68.9117V33.0892H65.5279V31.5715C64.5611 32.7096 63.2318 33.3421 61.6607 33.3421ZM62.3853 30.0538C63.3521 30.0538 64.0771 29.6744 64.6815 29.0421C65.2856 28.4097 65.6481 27.5244 65.6481 26.5126C65.6481 25.5008 65.2856 24.7421 64.6815 23.9833C64.0771 23.3508 63.3521 22.9715 62.3853 22.9715C61.4185 22.9715 60.6933 23.3508 59.9682 23.9833C59.364 24.6156 59.0015 25.5008 59.0015 26.5126C59.0015 27.5244 59.364 28.4097 59.9682 29.0421C60.5726 29.6744 61.4185 30.0538 62.3853 30.0538Z",
    fill: "#1264E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4758 19.0513C53.0802 19.0513 53.4427 18.7983 53.8053 18.4188C54.1678 18.0394 54.4095 17.5336 54.4095 17.0276C54.4095 16.3954 54.1678 16.0158 53.8053 15.6365C53.4427 15.2572 52.9592 15.0042 52.4758 15.0042C51.9924 15.0042 51.5091 15.2572 51.1465 15.6365C50.784 16.0158 50.6631 16.5217 50.6631 17.0276C50.6631 17.5336 50.784 18.0394 51.1465 18.4188C51.5091 18.7983 51.9924 19.0513 52.4758 19.0513Z",
    fill: "#1264E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopiaLogoWhite);
export default __webpack_public_path__ + "static/media/topiaLogo-white.83433d46012576761e5c9e385fd0c063.svg";
export { ForwardRef as ReactComponent };